/* ══════════════════════════════════════════════════════════════════
   **Welche Preise gerade unterwegs sind** (Prüfrunde Runde 12, N12-01;
   05.10.2026).

   Nach „Wie zuletzt" stand am Telefon eine Sekunde lang „Preis offen" an
   beiden Posten und darunter **„Summe netto 0,00 — 2 Zeile(n) ohne Preis"**,
   bevor „525,00" kam. Die Posten aus einer Wiederholung bringen keinen
   Betrag mit (Regel 4); die Karte holt ihn sofort (`GET /preis`). Solange
   diese Antwort fehlt, ist „0,00" eine Aussage über eine Antwort, die es
   nicht gibt — dieselbe Regel wie `daten/ladestand.ts`, nur dass die Abfrage
   hier an der Karte hängt und die Summe ein paar Zeilen tiefer steht.

   Wer einen Preis holt, meldet den Posten hier an (`usePreisfrageMelden`);
   wer eine Summe zeigt, fragt `usePreiseUnterwegs()` und zeigt „…", solange
   einer fehlt. Kommt die Antwort — oder ein Fehler —, meldet sich die Karte
   ab: Dann ist „Preis offen" wieder die Wahrheit.
   ══════════════════════════════════════════════════════════════════ */

import { useLayoutEffect, useSyncExternalStore } from "react";

/** Posten-Kennung → wie viele Stellen gerade für ihn fragen (Karte und Abschluss können es beide). */
const laufend = new Map<string, number>();
const hoerer = new Set<() => void>();
let stand = 0;

function melden(): void {
  stand += 1;
  hoerer.forEach((h) => h());
}

/** Eine Stelle fragt jetzt den Preis dieses Postens. Die Rückgabe meldet wieder ab. */
export function preisfrageAnmelden(id: string): () => void {
  laufend.set(id, (laufend.get(id) ?? 0) + 1);
  melden();
  let fertig = false;
  return () => {
    if (fertig) return;
    fertig = true;
    const rest = (laufend.get(id) ?? 1) - 1;
    if (rest > 0) laufend.set(id, rest);
    else laufend.delete(id);
    melden();
  };
}

/** Fehlt gerade irgendein Preis — oder einer dieser Posten? */
export function preiseUnterwegs(ids?: readonly string[]): boolean {
  if (!ids) return laufend.size > 0;
  return ids.some((id) => laufend.has(id));
}

/**
 * Meldet den Posten an, solange `laeuft` gilt. **Vor dem Zeichnen**
 * (`useLayoutEffect`): sonst stünde für ein Bild „0,00" da.
 */
export function usePreisfrageMelden(id: string, laeuft: boolean): void {
  useLayoutEffect(() => (laeuft ? preisfrageAnmelden(id) : undefined), [id, laeuft]);
}

function anmelden(h: () => void): () => void {
  hoerer.add(h);
  return () => { hoerer.delete(h); };
}

/** Ob die Summe gerade auf eine Antwort wartet. */
export function usePreiseUnterwegs(): boolean {
  useSyncExternalStore(anmelden, () => stand, () => stand);
  return preiseUnterwegs();
}
